<template lang="pug">
	.audio-tracker-wapi-plugin--row
		.space(:class="[isVertical ? 'flex-col align-center' : 'flex-row']")
			.elem.flex-1(v-for="(elem, elemIdx) in row")
				template(v-if="elem.rows")
					template(v-for="subRow in elem.rows")
						audio-tracker-wapi-plugin-row(:row="subRow", @value-change="onElemValueChange", :isVertical="elem.orientation === 'vertical'", :value="value")
				template(v-else)
					template(v-if="elem.kind === 'affector'")
						RoundButton(v-if="elem.type ==='round-button'", v-bind="elem", :value="elem.getValue()", @change="v => onElemValueChange(elem, v, elemIdx)")
						SliderButton(v-if="elem.type ==='slider'", v-bind="elem", :value="elem.getValue()", @change="v => onElemValueChange(elem, v, elemIdx)")
						SelectMenu(v-if="elem.type ==='select-menu'", v-bind="elem", :value="elem.getValue()", @change="v => onElemValueChange(elem, v, elemIdx)")
						.full-height.flex-col.full-width.align-center.center(v-if="elem.type === 'switch' && elem.title", :style="{ '--color': elem.color || '#f27649' }")
							.switch.upper(:class="{ 'active': elem.getValue() }", @click="onElemValueChange(elem, elem.getValue() ? 0 : 1, elemIdx)") {{elem.title}}
					.flex-col.full-height.align-center.center(v-if="elem.kind === 'indicator'", :style="getStyle(elem)")
						.flex-row.align-center.center.text-center(v-if="elemHasTitle(elem)")
							.font-mini.upper {{elem.title}}
						AudioTrackerVUMeter(v-if="elem.type === 'vu-meter'", v-bind="elem", :manualValue="elem.getValue()")
						.full-height.flex-col(v-if="elem.type === 'value'", :style="{ width: elem.width || 'auto' }")
							.value-indicator.flex-col.center.align-center(:style="getIndicatorStyle(elem)")
								span {{elem.getValue()}}
						.flex-col.full-width(v-if="elem.type === 'divider'", :style="{ width: elem.width || '100%' }")
							.value-divider.flex-row.center.align-center(:style="getIndicatorStyle(elem)")
								.flex-1.line.left
								.value {{elem.getValue()}}
								.flex-1.line.right
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import Loader from 'app-core/Loader.vue';
	import SliderButton from '../AudioTrackerSliderButton.vue';
	import RoundButton from '../AudioTrackerRoundButton.vue';
	import AudioTrackerVUMeter from '../AudioTrackerVUMeter.vue';
	import SelectMenu from '../AudioTrackerSelectMenu.vue';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker-wapi-plugin-row',
		components: { DxButton, Loader, SliderButton, RoundButton, AudioTrackerVUMeter, DxCheckBox, SelectMenu },
		props: ['row', 'isVertical', 'value'],
		data() {
			return {
				elemsValues: []
			}
		},
		watch: {
			row: {
				handler() {
					this.checkUids();
				},
				deep: true
			},
			value: {
				handler() {
					this.$refreshDisplayValues();
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__) {
				if (this.row?.length && this.row[0].type) {
					window[`wapiRowElem_${this.row[0].type}`] = this;
				}
			}

			this.$refreshDisplayValues = _.debounce(() => this.$forceUpdate(), 200, {
				leading: false,
				trailing: true,
				maxWait: 500
			});

			this.checkUids();
		},
		destroyed() {
			delete this.$refreshDisplayValues;
		},
		methods: {
			elemHasTitle(elem) {
				return elem.title && !['divider'].includes(elem.type);
			},
			uuidv4() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
				});
			},
			checkUids() {
				this.row.map(f => !f.uid && this.$set(f, 'uid', this.uuidv4()));
			},
			onElemValueChange(elem, v, elemIdx) {
				if (__DEBUG__)
					console.debug('onElemValueChange', { elem, v, elemIdx, elemValue: this.elemsValues[elem.uid] });
				if (this.elemsValues[elem.uid] !== v) {
					if (__DEBUG__)
						console.debug('Row value changed');
					this.elemsValues[elem.uid] = v;
					this.$emit('value-change', elem, v);
				}
			},
			getStyle(elem) {
				var style = {};
				if (elem.color) {
					style.color = elem.color;
				}
				return style;
			},
			getIndicatorStyle(elem) {
				var style = {};
				if (elem.color) {
					style.color = elem.color;
				}
				if (elem.height) {
					style.height = elem.height;
				}
				return style;
			}
		}
	};
</script>
<style lang="scss">
	.audio-tracker-wapi-plugin--row {
		.value-indicator {
			padding: 10px;
			background: #ffffff0a;
			border-radius: 7px;
			margin: 2px;
			pointer-events: none;
			white-space: nowrap;
		}
		
		.value-divider {
			margin: 2px;
			border-radius: 4px;
			position: relative;

			> .line {
				position: relative;
				&:before {
					position: absolute;
					content: '';
					top: 50%;
					height: 1px;
					background: rgba(0,0,0,0.15);
					left: 0px;
					right: 0px;
				}

				&.left:before {
					right: 20px;
				}

				&.right:before {
					left: 20px;
				}
			}
		}
	}
</style>